import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { format } from "date-fns";
import { pushEvent } from "@/lib/gtm";

export default function NewsCard({ post }) {
  return (
    <Link to={`/news/${post.slug}`}
      onClick={() => pushEvent("news_article_click", { article_title: post.title, article_slug: post.slug, category: post.category || "none" })}
      className="group bg-white border border-gray-200 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#E4001C]/40 flex flex-col">
      {post.featured_image ? (
        <div className="overflow-hidden">
          <img src={post.featured_image} alt={post.featured_image_alt || post.title} loading="lazy" decoding="async"
            className="w-full aspect-[16/9] object-cover group-hover:scale-105 transition-transform duration-500" />
        </div>
      ) : (
        <div className="w-full aspect-[16/9] bg-[#0A0A0A] flex items-center justify-center">
          <span className="font-heading font-extrabold uppercase text-white/20 text-2xl">SEISFRA</span>
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center gap-3 text-xs font-tech uppercase tracking-widest mb-3">
          {post.category && <span className="text-[#E4001C]">{post.category}</span>}
          {post.published_date && <span className="text-gray-400">{format(new Date(post.published_date), "MMM d, yyyy")}</span>}
        </div>
        <h3 className="font-tech font-semibold uppercase tracking-wide text-xl text-[#171717] group-hover:text-[#E4001C] transition-colors">{post.title}</h3>
        {post.excerpt && <p className="text-sm text-[#171717]/60 leading-relaxed mt-3 flex-1 line-clamp-3">{post.excerpt}</p>}
        <span className="font-tech font-semibold uppercase tracking-widest text-sm text-[#171717] group-hover:text-[#E4001C] transition-colors inline-flex items-center gap-1 mt-6">
          Read More <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
}